import type { IconDefinition } from '../index.tsx';

export const iconUpload: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconUpload',
  icon: [
    16,
    16,
    [],
    '',
    'M3 6L6 6L6 12L10 12L10 6L13 6V5L8 0L3 5L3 6Z M2 16L14 16V14L2 14V16Z',
  ],
};
